import { useCallback } from 'react';
import { DraftFunction } from 'use-immer';
import TextField from 'components/form/TextField';
import { PolicyItem } from 'models/policiesV2/dto';
import styles from '../index.module.css';

type Props = {
	value: string;
	setFormData: (arg: DraftFunction<PolicyItem>) => void;
	error: string;
	setError: (e: string) => void;
};

function PolicyName(props: Props) {
	const { value, setFormData, error, setError } = props;

	const setName = useCallback((name) => {
		setFormData((draft) => {
			draft.name = name;
		});

		if (name.length > 255) {
			setError('Maximum Name length is 255');
		} else {
			setError('');
		}
	}, []);

	return (
		<div className={styles.name}>
			<TextField
				dataTest="policy-name-input"
				placeholder="Name"
				label="Name"
				value={value}
				onChange={(e) => setName(e.target.value)}
				helperText={error}
				error={!!error}
				optional={false}
			/>
		</div>
	);
}

export { PolicyName };
